var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "glyphicons-basic",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "595.281px",
    height: "396.85px",
    viewBox: "0 0 595.281 396.85",
    enableBackground: "new 0 0 595.281 396.85",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "menu",
    fill: "#333333",
    d: "M434.058,285.236v24.804c0,6.849-5.553,12.401-12.402,12.401H173.625 c-6.849,0-12.401-5.553-12.401-12.401v-24.804c0-6.849,5.552-12.401,12.401-12.401h248.031 C428.505,272.834,434.058,278.387,434.058,285.236z M421.656,74.409H173.625c-6.849,0-12.401,5.553-12.401,12.401v24.804 c0,6.849,5.552,12.401,12.401,12.401h248.031c6.85,0,12.402-5.553,12.402-12.401V86.811 C434.058,79.962,428.505,74.409,421.656,74.409z M421.656,173.622H173.625c-6.849,0-12.401,5.552-12.401,12.401v24.803 c0,6.85,5.552,12.401,12.401,12.401h248.031c6.85,0,12.402-5.552,12.402-12.401v-24.803 C434.058,179.174,428.505,173.622,421.656,173.622z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.938ac167919355309346d9f9839927d2.svg";
export { ForwardRef as ReactComponent };